// extracted by mini-css-extract-plugin
module.exports = {"root":"StageGrid_root__27X5z"};